var map = {
	"./async": [
		18,
		0
	],
	"./async.js": [
		18,
		0
	],
	"./microTasks": [
		19,
		1
	],
	"./microTasks.js": [
		19,
		1
	],
	"./setTimeoutDead": [
		20,
		2
	],
	"./setTimeoutDead.js": [
		20,
		2
	],
	"./simple": [
		21,
		3
	],
	"./simple.js": [
		21,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 41;
module.exports = webpackAsyncContext;